import script from "./ActivationViberPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationViberPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivationViberPage.vue?vue&type=style&index=0&id=3c16b25b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c16b25b"]])

export default __exports__